import React from "react";
import styled from "styled-components";
import SectionHeader from "../SectionHeader/SectionHeader";
import AllHiddenNotice from "../AllHiddenNotice/AllHiddenNotice";
import useIndicatorsVisibility from "../../../hooks/useIndicatorsVisibility";
import { INDICATOR_GROUP_BY_SECTION } from "../../../constants";

/** Section de la page : en-tête + contenu (ou bandeau si tout est masqué) */
const Section = ({ id, title, children }) => {
    const { isGroupAllHidden, setGroupVisible } = useIndicatorsVisibility();
    const group = INDICATOR_GROUP_BY_SECTION[id];

    return (
        <Wrapper id={id}>
            <SectionHeader sectionId={id} title={title} />
            {isGroupAllHidden(group) ? (
                <AllHiddenNotice onShow={() => setGroupVisible(group, true)} />
            ) : (
                children
            )}
        </Wrapper>
    );
};

export default Section;

const Wrapper = styled.section`
    margin-bottom: var(--prh-space-xl);
    scroll-margin-top: 80px;
`;
